import {MI} from "../init";

/**
 * @constructor
 * @returns {AnimsWinCounter}
 */
export default function AnimsWinCounter() {

    /** @type {MadnesObject} */
    this._winTextBg;

    /** @type {MadnesObject} */
    this._winText0;

    /** @type {MadnesObject} */
    this._winText1;

    /** @type {Function} */
    this._onUpdate = function(v) {};
}

AnimsWinCounter.prototype.setOnUpdate = function(f) {
    this._onUpdate = f;
};

AnimsWinCounter.prototype.create = function() {

    this._winTextBg = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 - 15, "winbg").setFrameName("null_1");
    this._winTextBg.setAnchor(0.5, 0.5);
    this._winTextBg.setVisible(false);

    this._winText0 = MI.addBitmapText("font_bigwins_edited", MI.getWi() / 2 - 1, MI.getHe() / 2 - 11, "", 72);
    this._winText0.setAnchor(0.5, 0.5);
    this._winText0.setVisible(false);

    this._winText1 = MI.addBitmapText("font_bigwins_edited", MI.getWi() / 2 - 4, MI.getHe() / 2 - 15, "", 72);
    this._winText1.setAnchor(0.5, 0.5);
    this._winText1.setVisible(false);
};

AnimsWinCounter.prototype.init = function() {
    this._winTextBg.setVisible(true);
    this._winTextBg.setScale(0, 0);

    this._winText0.setVisible(true);
    this._winText0.setScale(0, 0);

    this._winText1.setVisible(true);
    this._winText1.setScale(0, 0);

    this._winText0.setText("");
    this._winText1.setText("");
};

AnimsWinCounter.prototype._isFloat = function(n) {
    return parseFloat(n) !== parseInt(n, 10);
};

AnimsWinCounter.prototype._getIntLength = function(num) {
    var count = 0;
    num = "" + num;

    for(var i = 0; i < num.length; i++) {

        if(num[i] == "." || num[i] == ",") {
            break;
        }

        count++;
    }

    return count;
};

AnimsWinCounter.prototype._getWinTextBg = function(num, isFloat) {
    var intLen = this._getIntLength(num);
    var name = "null";

    if(intLen === 0 || intLen > 9) {
        return;
    }

    if(isFloat) {
        name += "_euro";
    }

    return name += "_" + intLen;
};

AnimsWinCounter.prototype._setTextBg = function(num, isFloat) {

    var bgName = this._getWinTextBg(num, isFloat);

    if(!bgName) {
        this._winTextBg.setVisible(false);
        return;
    }

//	this._winTextBg.setVisible(true);
    this._winTextBg.setFrameName(bgName);
};

AnimsWinCounter.prototype.setText = function(text) {

    var isFloat = false; //this._isFloat(text);
    this._setTextBg(text, isFloat);

//	if(isFloat) {
//		text = parseFloat(text).toFixed(2);
//	}

    //text = this._translateFloatChars();

    this._winText0.setText(text);
    this._winText1.setText(text);
};



AnimsWinCounter.prototype.run = function(win, time) {

    var _self = this;

    if(typeof time === "undefined") { time = 450; };

    return new Promise(function(res) {

        var obj = { 'val': 0 };

        MI.addTween().to(obj, { 'val': win }, {
            'duration': time,
            'update': function() {
                _self.setText(obj['val'] | 0);
                //_self._onUpdate(obj['val']);
            },
            'callback': function() {
                _self.setText(win);
                res();
            }
        });

        _self.scaleIn();

    });
};

AnimsWinCounter.prototype.scaleIn = function() {
    this._scaleIn(this._winTextBg);
    this._scaleIn(this._winText0);
    this._scaleIn(this._winText1);
};

/** @param {MadnesObject} obj */
AnimsWinCounter.prototype._scaleIn = function(obj) {

    MI.addTween().to(obj, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 220
    });
};

AnimsWinCounter.prototype.hide = function() {

    this._winTextBg.setVisible(false);
    this._winText0.setVisible(false);
    this._winText1.setVisible(true);

    this._winText0.setText("");
    this._winText1.setText("");
};